import "../css/main.scss";

import "./utils";
import "./events/main";
import "./components/main";

/**
 * Dynamic Module Loading Pattern
 * Matches elements presence to avoid loading unnecessary code
 */

// Popups & Mobile Interactions
if (document.querySelector('.popup') || document.querySelector('.header__burger') || document.querySelector('.header__search-btn')) {
    import(/* webpackChunkName: "popups" */ "./popups/main").catch(err => console.error("Popups module failed:", err));
}

// Swiper-based sliders (Individual chunks for granular control)
if (document.querySelector('.doctors__slider')) {
    import(/* webpackChunkName: "doctors-slider" */ './components/sliders/doctors-slider').catch(err => console.error("Doctors Slider failed:", err));
}

if (document.querySelector('.treating-doctor__slider.swiper')) {
    import(/* webpackChunkName: "treating-doctors-slider-v2" */ './components/sliders/treating-doctors-slider').catch(err => console.error("Treating Doctors Slider failed:", err));
}

if (document.querySelector('.reviews__slider')) {
    import(/* webpackChunkName: "reviews-slider" */ './components/sliders/reviews-slider').catch(err => console.error("Reviews Slider failed:", err));
}

if (document.querySelector('.slider-photo__slider')) {
    import(/* webpackChunkName: "photo-slider" */ './components/sliders/photo-slider').catch(err => console.error("Photo Slider failed:", err));
}

if (document.querySelector('.partners__slider')) {
    import(/* webpackChunkName: "partners-slider" */ './components/sliders/partners-slider').catch(err => console.error("Partners Slider failed:", err));
}

if (document.querySelector('.marquee__slider')) {
    import(/* webpackChunkName: "marquee-slider" */ './components/sliders/marquee-slider').catch(err => console.error("Marquee Slider failed:", err));
}

if (document.querySelector('.news__slider')) {
    import(/* webpackChunkName: "news-slider" */ './components/sliders/news-slider').catch(err => console.error("News Slider failed:", err));
}

if (document.querySelector('.certificates__slider')) {
    import(/* webpackChunkName: "certificates-slider" */ './components/sliders/certificates-slider').catch(err => console.error("Certificates Slider failed:", err));
}

if (document.querySelector('.specialization__slider')) {
    import(/* webpackChunkName: "specialization-slider" */ './components/sliders/specialization-slider').catch(err => console.error("Specialization Slider failed:", err));
}

if (document.querySelector('.where__slider')) {
    import(/* webpackChunkName: "where-slider" */ './components/sliders/where-slider').catch(err => console.error("Where Slider failed:", err));
}

if (document.querySelector('.why__slider')) {
    import(/* webpackChunkName: "why-slider" */ './components/sliders/why-slider').catch(err => console.error("Why Slider failed:", err));
}

if (document.querySelector('.services-equipment__slider')) {
    import(/* webpackChunkName: "equipment-slider" */ './components/sliders/equipment-slider').catch(err => console.error("Equipment Slider failed:", err));
}

if (document.querySelector('.directions-equipment__slider')) {
    import(/* webpackChunkName: "directions-equipment-slider" */ './components/sliders/directions-equipment-slider').catch(err => console.error("Directions Equipment Slider failed:", err));
}

if (document.querySelector('.services-contraindications__slider')) {
    import(/* webpackChunkName: "contraindications-slider" */ './components/sliders/contraindications-slider').catch(err => console.error("Contraindications Slider failed:", err));
}

if (document.querySelector('.drip-list__slider')) {
    import(/* webpackChunkName: "drip-list-slider" */ './components/sliders/drip-list-slider').catch(err => console.error("Drip List Slider failed:", err));
}
